import React, { Component } from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import config from 'config';

class RedirectToBankForm extends Component {
  $formRef = React.createRef();

  componentDidMount() {
    const paymentPage =
      process.env.NODE_ENV === 'development'
        ? `/static/payment.html`
        : `${config.basePath}/static/payment.html`;
    this.popup$ = window.open(paymentPage, 'payment');
  }

  handleError = () => {
    if (this.popup$) {
      this.popup$.document.write('<p>Ошибка перехода в банк. Попробуйте позже.</p>');
      setTimeout(() => {
        this.popup$.close();
      }, 2000);
    }
  };

  formSubmit(fromData, isGpbExtended) {
    const inputList = this.$formRef.current.querySelectorAll('input');
    inputList.forEach((input) => {
      if (fromData[input.name]) {
        input.value = isGpbExtended
          ? encodeURIComponent(fromData[input.name])
          : fromData[input.name];
        input.removeAttribute('disabled');
      } else input.setAttribute('disabled', 'disabled');
    });
    this.$formRef.current.submit();
    inputList.forEach((input) => {
      input.value = '';
      input.removeAttribute('disabled');
    });
  }
  render() {
    const { bankActionUrl, encType, formInputNames } = this.props;
    return (
      <form
        ref={this.$formRef}
        method={'POST'}
        action={bankActionUrl}
        target={'payment'}
        hidden={true}
        encType={encType}
      >
        {map(formInputNames, (name) => (
          <input type={'hidden'} name={name} key={name} />
        ))}
      </form>
    );
  }
}

RedirectToBankForm.propTypes = {
  bankActionUrl: PropTypes.string,
  formRef: PropTypes.func,
  encType: PropTypes.string,
  formInputNames: PropTypes.array,
};
RedirectToBankForm.defaultProps = {};

export default RedirectToBankForm;
